import { render, staticRenderFns } from "./PublicationStorageExpansionTable.vue?vue&type=template&id=50e725f8&"
import script from "./PublicationStorageExpansionTable.vue?vue&type=script&lang=js&"
export * from "./PublicationStorageExpansionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports